import api from "./auth";
import { showAlert } from "./alerts";

export default logout = async () => {
  try {
    const { data } = await api.post(
      "/api/v1/users/logout"
    );
    if (data.status === "success") {
      showAlert("success", "Logout Successfuly!");
      window.location.assign('/login');
    }
  } catch (error) {
    showAlert("error", error.response.data.messsage);
  }
};
